import { useAuthStore } from '@/features/auth/useAuthStore.js'
import { isFullSuperAdminProfileType } from '@/features/currentUser/constants'

export function fullSuperAdminGuard(to, from, next) {
  const authStore = useAuthStore()

  if (isFullSuperAdminProfileType(authStore.myDetails?.type)) {
    next()
    return
  }

  next('/no-access?reason=full-super-admin-required')
}
